export default "__VITE_ASSET__8d6c26b7__"